import * as React from 'react'

import {
  Box,
  Button,
  Card,
  Grid,
  IconBadge,
  Text,
  Title,
} from '@factorialco/deprecated-design-system'
import { AtsJobPostingSettingsSmartActionsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { Item } from './Item'
import { NewSmartAction } from './NewSmartAction'

interface PhaseChangedActionProps {
  smartActions: AtsJobPostingSettingsSmartActionsFragment[]
  jobId: number
}

export const PhaseChangedAction = ({ smartActions, jobId }: PhaseChangedActionProps) => {
  const [showNewActionSidepanel, setShowNewActionSidepanel] = React.useState(false)
  const hasActions = smartActions.length > 0

  return (
    <Box gap="s16">
      <Title
        title={i18n.t('ats.job_posting_settings.smart_actions.actions.phase_changed.title')}
        description={i18n.t(
          'ats.job_posting_settings.smart_actions.actions.phase_changed.description'
        )}
        variant="400"
        illustrationComponent={
          <IconBadge icon="arrow-right" size="s32" color="grey200" iconColor="grey800" />
        }
      >
        {hasActions && (
          <Button onClick={() => setShowNewActionSidepanel(true)} type="secondary" iconName="add">
            {i18n.t('ats.job_posting_settings.smart_actions.actions.create_new')}
          </Button>
        )}
      </Title>

      {hasActions ? (
        <Grid variant="medium">
          {smartActions.map((action) => (
            <Box gridColSpan={{ xs: 1, s: 2 }} key={`smart-action-item-${action.id}`}>
              <Item
                title={i18n.t(
                  'ats.job_posting_settings.smart_actions.actions.phase_changed.item.title'
                )}
                selectedSmartAction={action}
                smartActions={smartActions}
              />
            </Box>
          ))}
        </Grid>
      ) : (
        <Card>
          <Card.Title size="small">
            {i18n.t(
              'ats.job_posting_settings.smart_actions.actions.phase_changed.empty_view.title'
            )}
          </Card.Title>
          <Card.Content>
            <Box gap="s8">
              <Text.Normal color="grey800">
                {i18n.t(
                  'ats.job_posting_settings.smart_actions.actions.phase_changed.empty_view.description'
                )}
              </Text.Normal>
              <Button
                onClick={() => setShowNewActionSidepanel(true)}
                type="secondary"
                iconName="add"
              >
                {i18n.t('ats.job_posting_settings.smart_actions.actions.create_new')}
              </Button>
            </Box>
          </Card.Content>
        </Card>
      )}

      {showNewActionSidepanel && (
        <NewSmartAction
          title={i18n.t('ats.job_posting_settings.smart_actions.sidepanel.phase_changed_new_title')}
          open={showNewActionSidepanel}
          onClose={() => setShowNewActionSidepanel(false)}
          jobId={jobId}
          smartActions={smartActions}
          actionType="phase_changed"
        />
      )}
    </Box>
  )
}
